export const BASE_URL: string = process.env.REACT_APP_API_KEY || "";
// const BASE_URL: string = "http://178.128.61.122:8084";

// Merchant stores
export const MERCHANT_STORE_FIND_MANY: string =
  BASE_URL + "/merchant/merchant-store/find-many";
export const MERCHANT_STORE_UPDATE: string =
  BASE_URL + "/merchant/merchant-store/update";
export const MERCHANT_STORE_FIND_ONE: string =
  BASE_URL + "/merchant/merchant-store/find-one";
// Merchant Users
export const MERCHANT_LOGIN: string = BASE_URL + "/merchant/login/login";
export const MERCHANT_USER_FIND_BY_TOKEN: string =
  BASE_URL + "/merchant/merchant-user/find-by-token";
export const MERCHANT_REFRESH_TOKEN: string =
  BASE_URL + "/merchant/login/refresh-token";
export const MERCHANT_USER_FIND_MANY: string =
  BASE_URL + "/merchant/merchant-user/find-many";
